<template>
  <div id="prozess-sidebar-modal" class="modal fade sidebar">
    <div class="modal-dialog">
      <div class="modal-content" style="min-height: 100vh">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{ $t("global.processes") }}</h4>
        </div>
        <div class="modal-body">
          <div
            v-if="prozesslaeufe?.length === 0"
            class="text-primary d-flex"
            style="height: 100%; justify-content: center; align-items: center"
          >
            <span>{{ $t("global.noProcessAssigned") }}</span>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div
                class="px-3 py-2"
                v-for="prozessGruppe in gruppierteProzesslaeufe"
                :key="prozessGruppe.id"
              >
                <span class="text-primary" style="font-size: 20px">{{
                  prozessGruppe.bezeichnung
                }}</span>

                <div class="prozesstabs d-flex">
                  <div
                    @click="
                      $set(gruppenShowStatus, prozessGruppe.id, 'laufend')
                    "
                    :class="{
                      active: prozessGruppe.show === 'laufend',
                      listenreiter: true,
                    }"
                  >
                    {{ $t("global.ongoing") }}
                  </div>
                  <div
                    @click="
                      $set(gruppenShowStatus, prozessGruppe.id, 'abgeschlossen')
                    "
                    :class="{
                      active: prozessGruppe.show === 'abgeschlossen',
                      listenreiter: true,
                    }"
                  >
                    {{ $t("global.completed") }}
                  </div>
                  <b-button
                    variant="outline-success"
                    v-tooltip="$t('global.saveprocess')"
                    class="save-button"
                    @click="saveCheckpunkteOfProzessGruppe(prozessGruppe)"
                  >
                    <font-awesome-icon :icon="['far', 'floppy-disk']" />
                  </b-button>
                </div>

                <div class="row">
                  <div class="col-xl-12 block belegliste br-t-l-0">
                    <b-table
                      ref="prozessTable"
                      class="text-center"
                      thead-class=""
                      :tbody-tr-class="rowClassFunctionProzesslauf"
                      responsive
                      hover
                      show-empty
                      :items="
                        gefilterteUndSortierteProzesslaeufe(prozessGruppe)
                      "
                      :fields="fields"
                      @sort-changed="onSortChanged"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      no-local-sorting
                    >
                      <template #cell(informationen)="row">
                        <div
                          v-html="row.item.informationen"
                          style="word-break: break-word"
                        ></div>
                      </template>

                      <template #cell(details)="row">
                        <b-button
                          @click="row.toggleDetails"
                          class="m-0"
                          variant="outline-primary"
                          size="sm"
                          v-tooltip="$t('global.checklist')"
                        >
                          <font-awesome-icon
                            :icon="
                              row.detailsShowing
                                ? 'fa-chevron-up'
                                : 'fa-chevron-down'
                            "
                          />
                        </b-button>
                      </template>
                      <template #row-details="row">
                        <div class="mb-2">
                          <div class="text-left">
                            {{ $t("global.checklist") }}
                          </div>
                          <b-table
                            thead-class="z"
                            small
                            responsive
                            sticky-header
                            :items="row.item.checkliste"
                            :fields="checklistefields"
                            show-empty
                            sort-icon-left
                            thead-tr-class="pointer no-bg"
                            striped
                            :tbody-tr-class="
                              (item, type) =>
                                rowClassFunctionCheckpunkt(item, type, row.item)
                            "
                          >
                            <template #cell(titel)="data">
                              {{ data.item.titel }}
                              <div class="bemerkung">
                                <textarea
                                  v-if="data.item.bearbeiten"
                                  v-model="data.item.bemerkung"
                                  :placeholder="$t('global.comment')"
                                  class="rounded auto-resize-textarea"
                                  @input="autoResize($event)"
                                  ref="bemerkungTextarea"
                                  rows="1"
                                >
                                </textarea>

                                <span v-else>
                                  {{
                                    getBemerkungText(data.item)
                                      ? getBemerkungText(data.item)
                                      : $t("global.nocomment")
                                  }}
                                </span>

                                <b-button
                                  v-if="
                                    data.item.bemerkung &&
                                    data.item.bemerkung.length > 55 &&
                                    !data.item.bearbeiten
                                  "
                                  size="sm"
                                  variant="light"
                                  class="expand-button"
                                  @click="toggleExpand(data.item)"
                                >
                                  {{
                                    data.item._expandBemerkung
                                      ? $t("global.less")
                                      : $t("global.more")
                                  }}
                                </b-button>

                                <b-button
                                  v-if="!data.item.bearbeiten"
                                  @click="
                                    $set(data.item, 'bearbeiten', true);
                                    $nextTick(() => resizeAllTextareas());
                                  "
                                  variant="outline-primary"
                                  size="sm"
                                  v-tooltip="$t('global.edit')"
                                >
                                  <font-awesome-icon icon="pencil" />
                                </b-button>
                              </div>
                            </template>

                            <template #cell(number)="cellRow">
                              {{ cellRow.index + 1 }}
                            </template>

                            <!-- <template v-slot:cell(bemerkung)="cellRow">
                              <textarea
                                v-if="cellRow.item.bearbeiten"
                                v-model="cellRow.item.bemerkung"
                                :placeholder="$t('global.comment')"
                                class="rounded"
                              >
                              </textarea>

                              <span v-else>
                                {{ cellRow.item.bemerkung }}
                              </span>

                              <b-button
                                v-if="!cellRow.item.bearbeiten"
                                @click="$set(cellRow.item, 'bearbeiten', true)"
                                variant="outline-primary"
                                size="sm"
                                v-tooltip="$t('global.edit')"
                              >
                                <font-awesome-icon icon="pencil" />
                              </b-button>
                            </template> -->

                            <template v-slot:cell(funktion)="cellRow">
                              <b-button
                                v-if="cellRow.item.aktion"
                                variant="outline-info"
                                size="sm"
                                @click="checkNext(row.item)"
                                :disabled="
                                  cellRow.index !==
                                  getFirstUncheckedIndex(row.item.checkliste)
                                "
                                v-tooltip="cellRow.item.aktion.beschreibung"
                              >
                                {{ cellRow.item.aktion.bezeichnung }}
                              </b-button>
                              <span
                                v-if="cellRow.item.action_last_triggered"
                                style="
                                  font-weight: 400;
                                  font-size: 11px;
                                  white-space: nowrap;
                                  display: block;
                                "
                                >{{ $t("global.lasttriggered") }}<br />
                                {{
                                  cellRow.item.action_last_triggered.slice(
                                    0,
                                    -3
                                  )
                                }}
                              </span>
                            </template>

                            <template v-slot:cell(erledigt)="cellRow">
                              <span
                                v-tooltip="
                                  getCheckboxTooltipText(
                                    cellRow,
                                    row.item.checkliste
                                  )
                                "
                              >
                                <b-form-checkbox
                                  v-model="cellRow.item.erledigt"
                                  :disabled="
                                    isDisabled(
                                      cellRow.index,
                                      row.item.checkliste
                                    ) ||
                                    isNextItemAndHasAktion(
                                      cellRow.index,
                                      row.item.checkliste
                                    )
                                  "
                                  @change="
                                    handleCheckboxChange(
                                      cellRow.index,
                                      $event,
                                      row.item
                                    )
                                  "
                                ></b-form-checkbox>
                              </span>
                              <span
                                v-if="cellRow.item.lastchecked"
                                style="
                                  font-weight: 400;
                                  font-size: 11px;
                                  white-space: nowrap;
                                  display: block;
                                "
                                >{{ $t("global.lastchecked") }}<br />
                                {{ cellRow.item.lastchecked.slice(0, -3) }}
                              </span>
                            </template>

                            <template #table-busy>
                              <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                              </div>
                            </template>

                            <template #empty>
                              <div
                                v-if="ladeFehler"
                                class="text-center text-danger my-2"
                              >
                                <strong>{{
                                  $t("global.errorwhileloading")
                                }}</strong>
                              </div>
                              <div
                                v-if="!ladeFehler"
                                class="text-center text-primary my-2"
                              >
                                <strong>{{
                                  $t("global.nodataavailable")
                                }}</strong>
                              </div>
                            </template>
                          </b-table>

                          <div class="mt-2 d-flex justify-content-center">
                            <b-button
                              class="mr-2"
                              variant="outline-primary"
                              @click="undoLast(row.item)"
                              :disabled="!row.item.checkliste[0]?.erledigt"
                              v-tooltip="
                                !row.item.checkliste[0]?.erledigt
                                  ? $t('global.topoflist')
                                  : $t('global.undo')
                              "
                            >
                              <font-awesome-icon
                                :icon="['far', 'arrow-rotate-left']"
                              />
                            </b-button>
                            <b-button
                              v-if="!istAbgeschlossen(row.item)"
                              variant="outline-primary"
                              @click="checkNext(row.item)"
                              v-tooltip="
                                nextItemWithAktion(row.item.checkliste)
                                  ? nextItemWithAktion(row.item.checkliste)
                                      .bezeichnung +
                                    ' ' +
                                    $t('global.andcomplete')
                                  : $t('global.done')
                              "
                            >
                              <font-awesome-icon icon="fa-check" />
                            </b-button>
                            <b-button
                              v-else
                              variant="outline-primary"
                              @click="completeChecklist(row.item)"
                              :disabled="true"
                              v-tooltip="$t('global.listcompleted')"
                            >
                              <font-awesome-icon icon="fa-check" />
                            </b-button>
                            <b-button
                              v-if="!row.item.abgeschlossen"
                              variant="outline-primary"
                              v-tooltip="$t('global.markprocessrunascompleted')"
                              class="save-button ml-2"
                              @click="setActivityDone(row.item)"
                            >
                              <font-awesome-icon icon="fa-check-double" />
                            </b-button>
                            <b-button
                              v-else
                              variant="outline-primary"
                              v-tooltip="
                                $t('global.markprocessrunasunfinished')
                              "
                              class="save-button ml-2"
                              @click="setProzesslaufUndone(row.item)"
                            >
                              <font-awesome-icon :icon="['far', 'xmark']" />
                            </b-button>
                            <b-button
                              variant="outline-success"
                              v-tooltip="$t('global.savechecklist')"
                              class="save-button ml-2"
                              @click="
                                saveCheckpunkteOfCheckliste(row.item.checkliste)
                              "
                            >
                              <font-awesome-icon
                                :icon="['far', 'floppy-disk']"
                              />
                            </b-button>
                          </div>
                        </div>
                      </template>
                      <template #table-busy>
                        <div class="text-center text-primary my-2">
                          <b-spinner class="align-middle"></b-spinner>
                        </div>
                      </template>

                      <template #empty>
                        <div
                          v-if="ladeFehler"
                          class="text-center text-danger my-2"
                        >
                          <strong>{{ $t("global.errorwhileloading") }}</strong>
                        </div>
                        <div
                          v-if="!ladeFehler"
                          class="text-center text-primary my-2"
                        >
                          <strong>{{ $t("global.nodataavailable") }}</strong>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>

              <!-- Bestätigungsmodal als Sidebar -->
              <b-modal
                v-model="showConfirmModal"
                sidebar
                right
                no-fade
                :hide-backdrop="true"
                :static="true"
                @ok="confirmUncheck(activeProzesslauf)"
                @hide="cancelUncheck(activeProzesslauf?.checkliste)"
                size="sm"
                dialog-class="custom-modal-dialog"
                :ok-title="$t('global.yes')"
                :cancel-title="$t('global.no')"
              >
                <template #modal-header>
                  <div class="position-relative w-100 text-center">
                    <h5 class="modal-title m-0">
                      {{ $t("global.confirmation") }}
                    </h5>
                    <div class="position-absolute" style="top: 0; right: 0">
                      <modal-close-button
                        @confirmed="showConfirmModal = false"
                      />
                    </div>
                  </div>
                </template>
                <p>
                  {{ $t("global.markcheckpointasunfinished") }}
                </p>
                <p v-if="hasSubsequentItems(activeProzesslauf?.checkliste)">
                  {{ $t("global.subsequentalsomarkedasunfinished") }}
                </p>
              </b-modal>

              <!-- Aktion-Bestätigungsmodal als Sidebar -->
              <b-modal
                v-model="showAktionConfirmModal"
                sidebar
                right
                no-fade
                :hide-backdrop="true"
                :static="true"
                size="sm"
                dialog-class="custom-modal-dialog"
              >
                <template #modal-header>
                  <div class="position-relative w-100 text-center">
                    <h5 class="modal-title m-0">
                      {{ $t("global.confirmation") }}
                    </h5>
                    <div class="position-absolute" style="top: 0; right: 0">
                      <modal-close-button
                        @confirmed="showAktionConfirmModal = false"
                      />
                    </div>
                  </div>
                </template>
                <p>
                  {{ $t("global.triggeragain") }}
                </p>
                <template #modal-footer>
                  <b-button
                    variant="danger"
                    @click="showAktionConfirmModal = false"
                    >{{ $t("global.cancel") }}</b-button
                  >
                  <b-button
                    variant="secondary"
                    @click="
                      prepareStepForward(activeProzesslauf, true);
                      showAktionConfirmModal = false;
                    "
                    >{{ $t("global.markdonewithoutexecuting") }}</b-button
                  >
                  <b-button
                    variant="primary"
                    @click="
                      prepareStepForward(activeProzesslauf);
                      showAktionConfirmModal = false;
                    "
                    >{{ $t("global.yes") }}</b-button
                  >
                </template>
              </b-modal>

              <!-- Bestätigungsmodal Pendenz abschliessen als Sidebar -->
              <b-modal
                v-model="showPendenzConfirmModal"
                sidebar
                right
                no-fade
                :hide-backdrop="true"
                :static="true"
                @ok="
                  prepareStepForward(activeProzesslauf, false, true);
                  showPendenzConfirmModal = false;
                "
                @cancel="
                  prepareStepForward(activeProzesslauf);
                  showPendenzConfirmModal = false;
                "
                @hide="showPendenzConfirmModal = false"
                size="sm"
                dialog-class="custom-modal-dialog"
                :ok-title="$t('global.yes')"
                :cancel-title="$t('global.no')"
              >
                <template #modal-header>
                  <div class="position-relative w-100 text-center">
                    <h5 class="modal-title m-0">
                      {{ $t("global.confirmation") }}
                    </h5>
                    <div class="position-absolute" style="top: 0; right: 0">
                      <modal-close-button
                        @confirmed="showPendenzConfirmModal = false"
                      />
                    </div>
                  </div>
                </template>
                <p>
                  {{ $t("global.setassociatedtaskcompleted") }}
                </p>
              </b-modal>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="closeModal">
            {{ $t("global.close") }}
          </button>
          <!-- <button type="button" class="btn btn-primary">
            {{ $t("global.save") }}
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCloseButton from "@/components/global/ModalCloseButtonNew";
import { BModal } from "bootstrap-vue";
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

export default {
  name: "ProzessSidebarModal",
  components: { ModalCloseButton, BModal },
  mixins: [],
  metaInfo() {},
  props: {},
  data() {
    return {
      gruppenShowStatus: {},
      sortBy: null,
      sortDesc: false,
      shown: false,
      ladeFehler: false,
      showConfirmModal: false,
      showAktionConfirmModal: false,
      activeProzesslauf: null,
      pendingIndex: -1, // Index der Checkbox, die abgewählt werden soll
      personId: null,
      prozesslaeufe: null,
      showPendenzConfirmModal: false,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "informationen",
          sortable: true,
          label: this.$t("global.information"),
          class: "text-left",
        },
        {
          key: "start",
          sortable: true,
          label: this.$t("global.start"),
        },
        {
          key: "end",
          sortable: true,
          label: this.$t("global.end"),
        },
        {
          key: "details",
          sortable: false,
          label: "",
        },
      ];
    },
    checklistefields() {
      return [
        {
          key: "number",
          label: "#",
          class: "text-right",
        },
        {
          key: "titel",
          label: this.$t("global.title"),
          class: "text-left",
        },
        // {
        //   key: "bemerkung",
        //   label: "Bemerkung",
        //   class: "text-left",
        // },
        {
          key: "funktion",
          label: this.$t("global.action"),
        },
        {
          key: "erledigt",
          label: this.$t("global.done"),
        },
      ];
    },
    gruppierteProzesslaeufe() {
      const gruppiert = {};

      this.prozesslaeufe?.forEach((lauf) => {
        const prozessId = lauf.prozess.id;

        if (!gruppiert[prozessId]) {
          gruppiert[prozessId] = {
            id: prozessId,
            bezeichnung: lauf.prozess.bezeichnung,
            prozesslaeufe: [],
          };

          if (!(prozessId in this.gruppenShowStatus)) {
            this.$set(this.gruppenShowStatus, prozessId, "laufend");
          }
        }

        gruppiert[prozessId].prozesslaeufe.push(lauf);
      });

      return Object.values(gruppiert).map((gruppe) => ({
        ...gruppe,
        show: this.gruppenShowStatus[gruppe.id],
      }));
    },
    numberProcesses() {
      if (this.prozesslaeufe) {
        return this.prozesslaeufe.filter((item) => item.abgeschlossen === false)
          .length;
      } else {
        return 0;
      }
    },
  },
  watch: {
    numberProcesses() {
      this.sendNumber();
    },
  },
  created() {},
  mounted() {
    this.$bus.$on("prozess-sidebar-modal-show", () => {
      if (!this.shown) this.openModal();
    });

    // Event-Listener für Bootstrap-Modal-Ereignisse
    $("#prozess-sidebar-modal").on("hidden.bs.modal", () => {
      this.shown = false;
    });

    this.getPersonId().then(() => {
      this.getProzesslaeufe();
    });

    this.$bus.$on("prozess-sidebar-reload", () => {
      this.getProzesslaeufe();
    });
  },
  beforeDestroy() {
    // Event-Listener entfernen, um Speicherlecks zu vermeiden
    $("#prozess-sidebar-modal").off("hidden.bs.modal");
    this.$bus.$off("prozess-sidebar-modal-show");
  },
  methods: {
    setActivityDone(prozesslauf) {
      this.saveCheckpunkteOfCheckliste(prozesslauf.checkliste).then(() => {
        AppApi.put(
          "prozesslauf/",
          {},
          {
            params: { action: "close", id: prozesslauf.id },
          }
        )
          .then((response) => {
            const updated = response.data;
            const index = this.prozesslaeufe.findIndex(
              (p) => p.id === updated.id
            );

            if (index !== -1) {
              const ziel = this.prozesslaeufe[index];
              Object.assign(ziel, updated);
            }

            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          });
      });
    },

    setProzesslaufUndone(prozesslauf) {
      this.saveCheckpunkteOfCheckliste(prozesslauf.checkliste).then(() => {
        AppApi.put(
          "prozesslauf/",
          {},
          {
            params: { action: "reopen", id: prozesslauf.id },
          }
        )
          .then((response) => {
            const updated = response.data;
            const index = this.prozesslaeufe.findIndex(
              (p) => p.id === updated.id
            );

            if (index !== -1) {
              const ziel = this.prozesslaeufe[index];
              Object.assign(ziel, updated);
            }

            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          });
      });
    },

    resizeAllTextareas() {
      const textareas = this.$refs.bemerkungTextarea;
      if (textareas) {
        (Array.isArray(textareas) ? textareas : [textareas]).forEach(
          (textarea) => {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
          }
        );
      }
    },

    autoResize(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },

    toggleExpand(item) {
      this.$set(item, "_expandBemerkung", !item._expandBemerkung);
    },

    getBemerkungText(item) {
      const bemerkung = item.bemerkung || "";
      if (item._expandBemerkung || bemerkung.length <= 55) return bemerkung;
      return bemerkung.slice(0, 55) + "...";
    },

    gefilterteUndSortierteProzesslaeufe(prozessGruppe) {
      const show = this.gruppenShowStatus[prozessGruppe.id];
      let result = prozessGruppe.prozesslaeufe.filter((lauf) =>
        show === "abgeschlossen" ? lauf.abgeschlossen : !lauf.abgeschlossen
      );

      // Sortierlogik manuell anwenden
      let field = this.sortBy;
      let desc = this.sortDesc;

      if (!field) {
        if (show === "laufend") {
          field = "start";
          desc = false;
        } else {
          field = "end";
          desc = true;
        }
      }

      result.sort((a, b) => {
        let valA = a[field];
        let valB = b[field];

        if (field === "start" || field === "end") {
          valA = this.parseDate(valA);
          valB = this.parseDate(valB);
        }

        if (!valA && !valB) return 0;
        if (!valA) return desc ? -1 : 1;
        if (!valB) return desc ? 1 : -1;

        if (valA < valB) return desc ? 1 : -1;
        if (valA > valB) return desc ? -1 : 1;
        return 0;
      });

      return result;
    },

    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
    },

    setBearbeitenFalseProzessGruppe(prozessGruppe) {
      prozessGruppe.prozesslaeufe.forEach((prozesslauf) => {
        prozesslauf.checkliste.forEach((checkpunkt) => {
          this.$set(checkpunkt, "bearbeiten", false);
        });
      });
    },

    setBearbeitenFalseCheckliste(checkliste) {
      checkliste.forEach((checkpunkt) => {
        this.$set(checkpunkt, "bearbeiten", false);
      });
    },

    saveCheckpunkteOfProzessGruppe(prozessGruppe) {
      this.setBearbeitenFalseProzessGruppe(prozessGruppe);

      const checkpunkteToSave = prozessGruppe.prozesslaeufe.flatMap((lauf) =>
        lauf.checkliste.map(({ bearbeiten, ...rest }) => rest)
      );

      return AppApi.put("checkpunkt/", checkpunkteToSave)
        .then(() => {
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        });
    },

    saveCheckpunkteOfCheckliste(checkliste) {
      this.setBearbeitenFalseCheckliste(checkliste);

      const checkpunkteToSave = checkliste.map(
        ({ bearbeiten, ...rest }) => rest
      );

      return AppApi.put("checkpunkt/", checkpunkteToSave)
        .then(() => {
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        });
    },

    // Modal-Steuerung
    openModal() {
      this.shown = true;

      $("#prozess-sidebar-modal").modal({
        backdrop: true,
        keyboard: false,
      });
    },
    closeModal() {
      $("#prozess-sidebar-modal").modal("hide");
    },

    // Checkliste-Helfer
    getLastCheckedIndex(checklist) {
      return checklist.reduce(
        (last, item, i) => (item.erledigt ? i : last),
        -1
      );
    },
    getFirstUncheckedIndex(checklist) {
      return checklist.findIndex((item) => !item.erledigt);
    },
    // Prüft, ob es nachfolgende erledigte Checkpunkte gibt
    hasSubsequentItems(checklist) {
      return (
        (this.pendingIndex >= 0 &&
          checklist
            ?.slice(this.pendingIndex + 1)
            .some((item) => item.erledigt)) ||
        false
      );
    },
    istAbgeschlossen(prozesslauf) {
      return prozesslauf.abgeschlossen;
    },
    isDisabled(index, checklist) {
      return index > 0 && !checklist[index - 1].erledigt;
    },
    nextItemWithAktion(checklist) {
      const nextItem = checklist.find((item) => !item.erledigt);
      return nextItem?.aktion || null;
    },
    isNextItemAndHasAktion(index, checklist) {
      return index === this.getFirstUncheckedIndex(checklist) &&
        this.nextItemWithAktion(checklist) &&
        !checklist[index].action_last_triggered
        ? true
        : false;
    },

    prepareStepForward(
      prozesslauf,
      skipAction = false,
      setActivityDone = false
    ) {
      const checklist = prozesslauf.checkliste;
      const index = this.getFirstUncheckedIndex(checklist);
      if (index !== -1) {
        this.stepForward(
          checklist[index].id,
          checklist,
          prozesslauf.prozess.id,
          skipAction,
          setActivityDone
        );
        // console.log("check: " + checklist[index].id);
      }
    },

    // Checkliste-Aktionen
    checkNext(prozesslauf) {
      const checklist = prozesslauf.checkliste;
      const index = this.getFirstUncheckedIndex(checklist);
      if (index !== -1) {
        if (checklist.length === index + 1) {
          this.activeProzesslauf = prozesslauf;
          this.showPendenzConfirmModal = true;
        } else if (checklist[index].action_last_triggered) {
          this.activeProzesslauf = prozesslauf;
          this.showAktionConfirmModal = true;
        } else {
          this.prepareStepForward(prozesslauf);
        }
      }
    },
    undoLast(prozesslauf) {
      this.pendingIndex = this.getLastCheckedIndex(prozesslauf.checkliste);
      this.activeProzesslauf = prozesslauf;
      this.showConfirmModal = true;
    },
    completeChecklist(prozesslauf) {
      // console.log("Prozesslauf abgeschlossen:", prozesslauf.id);
    },
    getCheckboxTooltipText(cellRow, checkliste) {
      const index = cellRow.index;
      const item = cellRow.item;

      if (this.isDisabled(index, checkliste)) {
        return this.$t("global.noteorder");
      }
      if (this.isNextItemAndHasAktion(index, checkliste)) {
        return this.$t("global.actionmustbeexecuted");
      }
      return item.erledigt ? this.$t("global.undo") : this.$t("global.done");
    },

    // Checkbox- und Modal-Logik
    handleCheckboxChange(index, newValue, prozesslauf) {
      if (newValue) {
        // Anwählen: Erlaubt, wenn Reihenfolge stimmt (dank :disabled)
        const checklist = prozesslauf.checkliste;
        checklist[index].erledigt = false;

        if (checklist.length === index + 1) {
          this.activeProzesslauf = prozesslauf;
          this.showPendenzConfirmModal = true;
        } else if (checklist[index].action_last_triggered) {
          this.prepareStepForward(prozesslauf, true);
        } else {
          this.prepareStepForward(prozesslauf);
        }
      } else {
        // Abwählen
        this.pendingIndex = index;
        this.activeProzesslauf = prozesslauf;
        this.showConfirmModal = true;
      }
    },
    confirmUncheck(prozesslauf) {
      const checklist = prozesslauf.checkliste;
      // Abwählen bestätigt: Setze diese und alle nachfolgenden auf false
      if (this.pendingIndex >= 0) {
        if (this.hasSubsequentItems(checklist) || prozesslauf.abgeschlossen) {
          this.stepTo(
            checklist[this.pendingIndex].id,
            checklist,
            prozesslauf.prozess.id
          );
          // console.log("uncheck multiple: " + checklist[this.pendingIndex].id);
        } else {
          // this.stepBackward(checklist[this.pendingIndex].id);
          this.stepBackward(
            prozesslauf.aktueller_checkpunkt_id,
            prozesslauf.checkliste,
            prozesslauf.prozess.id
          );
          // console.log("uncheck one: " + checklist[this.pendingIndex].id);
        }

        // checklist
        //   .slice(this.pendingIndex)
        //   .forEach((item) => (item.erledigt = false));

        this.resetPending();
      }
    },
    cancelUncheck(checklist) {
      if (checklist && this.pendingIndex >= 0) {
        // Abwählen abgebrochen: Ursprünglichen Zustand beibehalten
        checklist[this.pendingIndex].erledigt = true;
        this.resetPending();
      }
    },
    resetPending() {
      this.pendingIndex = -1;
      this.showConfirmModal = false;
    },

    getPersonId() {
      return Api.get("aktueller_mitarbeiter/")
        .then((response) => {
          this.personId = response.data.mitarbeiter.person.id;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        });
    },

    getProzesslaeufe() {
      return AppApi.get("prozesslauf/", {
        params: { personId: this.personId },
      })
        .then((response) => {
          this.prozesslaeufe = response.data;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        });
    },

    findProzessGruppeByCheckpunktId(checkpunktId) {
      return this.gruppierteProzesslaeufe.find((gruppe) =>
        gruppe.prozesslaeufe.some((lauf) =>
          lauf.checkliste.some((checkpunkt) => checkpunkt.id === checkpunktId)
        )
      );
    },

    stepForward(id, checkliste, prozessId, skipAction, setActivityDone) {
      this.saveCheckpunkteOfCheckliste(checkliste).then(() => {
        AppApi.put(
          `prozessschritt/${id}`,
          {},
          {
            params: {
              mode: "forward",
              prozessId: prozessId,
              skipActions: skipAction,
              setActivityDone: setActivityDone,
            },
          }
        )
          .then((response) => {
            const updated = response.data;
            const index = this.prozesslaeufe.findIndex(
              (p) => p.id === updated.id
            );

            if (index !== -1) {
              const ziel = this.prozesslaeufe[index];
              Object.assign(ziel, updated);
            }
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          });
      });
    },

    stepBackward(id, checkliste, prozessId) {
      this.saveCheckpunkteOfCheckliste(checkliste).then(() => {
        AppApi.put(
          `prozessschritt/${id}`,
          {},
          {
            params: { mode: "backward", prozessId: prozessId },
          }
        )
          .then((response) => {
            const updated = response.data;
            const index = this.prozesslaeufe.findIndex(
              (p) => p.id === updated.id
            );

            if (index !== -1) {
              const ziel = this.prozesslaeufe[index];
              Object.assign(ziel, updated);
            }
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          });
      });
    },

    stepTo(id, checkliste, prozessId) {
      this.saveCheckpunkteOfCheckliste(checkliste).then(() => {
        AppApi.put(
          `prozessschritt/${id}`,
          {},
          {
            params: { mode: "back_to", prozessId: prozessId },
          }
        )
          .then((response) => {
            const updated = response.data;
            const index = this.prozesslaeufe.findIndex(
              (p) => p.id === updated.id
            );

            if (index !== -1) {
              const ziel = this.prozesslaeufe[index];
              Object.assign(ziel, updated);
            }
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          });
      });
    },

    sendNumber() {
      this.$bus.$emit("number-processes", this.numberProcesses);
    },

    rowClassFunctionProzesslauf(item, type) {
      let baseClass = "item p-1";
      if (type === "row" && item.abgeschlossen) {
        return `${baseClass} abgeschlossen`;
      }
      return baseClass;
    },

    rowClassFunctionCheckpunkt(item, type, prozesslauf) {
      let baseClass = "item";
      if (
        type === "row" &&
        item.id === prozesslauf.aktueller_checkpunkt_id &&
        !prozesslauf.abgeschlossen
      ) {
        return `${baseClass} aktuellerCheckpunkt`;
      }
      return baseClass;
    },

    parseDate(dateStr) {
      if (dateStr) {
        const [day, month, year] = dateStr.split(".");
        return `${year}-${month}-${day}`;
      }
      return null;
    },

    sortiereProzesslaeufe() {
      this.prozesslaeufe?.sort((a, b) => {
        // Zuerst nach "abgeschlossen"
        if (a.abgeschlossen !== b.abgeschlossen) {
          return Number(a.abgeschlossen) - Number(b.abgeschlossen); // false vor true
        }

        // Dann nach Startdatum (älteste zuerst)
        return this.parseDate(a.start) - this.parseDate(b.start);
      });
    },
  },
};
</script>

<style lang="scss">
#prozess-sidebar-modal {
  /* .abgeschlossen > td {
    background-color: #cfffdb;
  } */

  .aktuellerCheckpunkt > td {
    background-color: #cfffdb;
  }

  .prozesstabs {
    .save-button {
      margin-left: auto;
      margin-bottom: 14px;
      padding: 6px 0 0;
      height: 38px;
      width: 38px;

      svg {
        height: 20px;
      }
    }

    .listenreiter {
      color: #124862;
      width: unset;
      max-width: unset;
      padding: 0.4rem 0.8rem;
      font-size: 16px;
      background: #cfdee9;
      margin-top: 14px;

      &.active {
        font-weight: 600;
        border: 1px solid;
        border-bottom: none;
        background: #deedf6;
      }
    }
  }

  .bemerkung {
    font-style: italic;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-top: 0.25rem;

    span {
      width: 100%;
    }

    button {
      margin-top: 3px;
    }
  }

  .auto-resize-textarea {
    width: 100%;
    resize: none; /* Deaktiviert manuelles Resizing */
    overflow: hidden; /* Verhindert Scrollleisten */
  }

  .expand-button {
    padding: 0.25rem !important;
    font-size: 0.75rem !important;
    height: 31px;
  }

  .belegliste .table td {
    vertical-align: top !important;
  }
}
</style>
